/* @flow */
import * as React from "react";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";

import Theme from "./Theme";

const LARGE_LAYOUT_BREAKPOINT = 800;

function getSafeViewportSize() {
  // iPhone X has a "safe area" which is smaller than the viewport size. It has
  // to be accessed through CSS env() values, so typically we use calc() to
  // inset the content. However, calc() is not supported in media queries, so in
  // order to determine the size of the safe area for laying out the app, we need
  // to use a non-media-query solution.
  let viewport = document.createElement("div");
  Object.assign(viewport.style, {
    position: "absolute",
    pointerEvents: "none",
    top: Theme.Padding.SAFE_AREA_TOP,
    right: Theme.Padding.SAFE_AREA_RIGHT,
    bottom: Theme.Padding.SAFE_AREA_BOTTOM,
    left: Theme.Padding.SAFE_AREA_LEFT,
  });
  document.body.appendChild(viewport);
  const size = viewport.clientWidth;
  document.body.removeChild(viewport);
  return size;
}

type Props = {
  children: React.Node,
};

type State = { isLargeAppLayout: boolean };

export default class AppContainerBreakpointProvider extends React.Component<
  Props,
  State
> {
  static childContextTypes = {
    isLargeAppLayout: PropTypes.bool,
  };

  state = {
    isLargeAppLayout: false,
  };

  getChildContext() {
    return { isLargeAppLayout: this.state.isLargeAppLayout };
  }

  UNSAFE_componentWillMount() {
    window.addEventListener("resize", this._examineViewport);
    this._examineViewport();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._examineViewport);
  }

  _examineViewport = throttle(() => {
    const size = getSafeViewportSize();
    const isLargeAppLayout = size > LARGE_LAYOUT_BREAKPOINT;
    if (this.state.isLargeAppLayout !== isLargeAppLayout) {
      this.setState({ isLargeAppLayout });
    }
  }, 16);

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/AppContainerBreakpointProvider.jsx